import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import INotification from "../../../models/INotification";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOrderOnGetCartOrdersDTO from "../../../models/DTO/IOrderOnGetCartOrdersDTO";
import IOrderGetCartOrdersDTO from "../../../models/DTO/IOrderGetCartOrdersDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import IOrder from "../../../models/IOrder";
import styled from "styled-components";
import OwTable from "../../shared/OwTable/OwTable";
import IOwTableCols from "../../../models/IOwTableCols";
import { EcommerceOrderDetailRow } from "../EcommerceOrderDetailRow/EcommerceOrderDetailRow";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwButton from "../../shared/OwButton/OwButton";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import { Socket } from "socket.io-client";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";

type Props = {};

const OrderSearchDiv = styled.div`
    margin-left: auto;
    display: flex;
    flex-direction: column;
`;

const OrderTableDiv = styled.div`
    margin-top: 1rem;
`;

export const EcommerceOrders: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [orders, setOrders] = useState<IOrder[]>([]);
    const [initialLoad, setInitialLoad] = useState(true);
    const [isDataFetching, setIsDataFetching] = useState(false);
    const [isSearchActive, setIsSearchActive] = useState(false);
    const [isReset, setIsReset] = useState(false);
    const [paginationChanged, setPaginationChanged] = useState(false);
    const [totalOrders, setTotalOrders] = useState<number>();
    const [orderSearch, setOrderSearch] = useState("");
    const [queryString, setQueryString] = useState("");
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        socket.on(EndpointsEnum.OrderOnGetCartOrders, onGetCartOrders);

        getCartOrders();

        document.title = "Orderwerks >> Orders";

        return () => {
            socket.removeListener(EndpointsEnum.OrderOnGetCartOrders, onGetCartOrders);
        };
    }, []);

    const getCartOrders = () => {
        const payload: IOrderGetCartOrdersDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: vendorModel.guid,
            limit,
            offset,
        };

        if (queryString.length) {
            payload.queryString = queryString;
        }

        socket.emit(EndpointsEnum.OrderGetCartOrders, payload);
    };

    const onGetCartOrders = (data: IOrderOnGetCartOrdersDTO) => {
        setOrders(data.orders);
        setTotalOrders(data.totalOrders);

        window.document.getElementById("mainView")!.scrollTo({ top: 0 });
    };

    useEffect(() => {
        setupQueryString();
    }, [orderSearch]);

    useEffect(() => {
        if (isReset) {
            search();
        }
    }, [isReset]);

    useEffect(() => {
        if (paginationChanged) {
            search();
        }
    }, [paginationChanged]);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        console.log("handleChange: ", value);

        switch (name) {
            case "order":
                setOrderSearch(value);
                break;
        }
    };

    const setupQueryString = () => {
        let _queryString = "";

        if (orderSearch.length) {
            _queryString += `?order=${orderSearch}`;
        }

        setQueryString(_queryString);
    };

    const search = () => {
        getCartOrders();

        setIsReset(false);
        setPaginationChanged(false);
    };

    const reset = () => {
        setOrderSearch("");
        setQueryString("");
        setIsReset(true);
    };

    const onPaginationChanged = (_offset: number, _limit: number) => {
        setLimit(_limit);
        setOffset(_offset);
        setPaginationChanged(true);
    };

    return (
        <div className={"EcommerceOrders"}>
            <div className={"container mt-3 mb-5"}>
                <OrderSearchDiv>
                    <div>
                        <div>
                            <OwLabel title={"order"} />
                        </div>
                        {orderSearch}
                        <div className={"w-13r"}>
                            <OwFnInput enableDebounce={false} fn={handleChange} name={"order"} value={orderSearch} />
                        </div>
                    </div>
                    <div className={"mt-2"}>
                        <OwButton title={"search"} fn={search} active={isSearchActive} />
                        <OwButton className={"btn-danger ms-2"} title={"reset"} fn={reset} active={isSearchActive} />
                    </div>
                </OrderSearchDiv>

                <div className={"mt-3"}>
                    {totalOrders ? (
                        <div>
                            {totalOrders} <OwLabel title={"orders"} />
                        </div>
                    ) : null}
                </div>
                <OrderTableDiv>
                    {orders.map((order) => {
                        return <EcommerceOrderDetailRow key={order.guid} order={order} />;
                    })}
                </OrderTableDiv>

                <div>
                    {totalOrders ? (
                        <PaginationBar offset={offset} limit={limit} totalRecords={totalOrders} onPaginationChanged={onPaginationChanged} />
                    ) : null}
                </div>
            </div>
        </div>
    );
};
